import moment from 'moment-timezone';

const TEMP_SUBSCRIPTION_TIME = 5;

export function hasValidSubscription(subscription) {
  return subscription?.id || (
    subscription?.date && moment().diff(moment(subscription?.date), 'minute') < TEMP_SUBSCRIPTION_TIME
  );
}

export function isOrganisationDifferent(orga, prevOrga) {
  const organisationId = orga?.organisationId;
  const prevOrganisationId = prevOrga?.organisationId;

  return organisationId !== undefined &&
    (
      prevOrganisationId === undefined ||
      prevOrganisationId !== organisationId
    );
}
